export const APP_INFO = {
  APP_VERSION: '0.0.1',
};

export const COMMON_INFO = {
  TERMINAL_ID: 300103, // 目前提单页使用
}